import DatePicker from "react-datepicker";
import { ErrorMessage, Field, Form, Formik } from "formik";
import dayjs from "dayjs";
import { useRef, useState } from "react";
import MultiFieldModal from "./MultiFieldModal";

const ResumeForm = ({
  initialValues,
  validationSchema,
  handleSubmit,
  role,
  handleBack,
}) => {
  console.log("engliah pdofd", initialValues.english_pdf);
  // const [newChip, setNewChip] = useState('');
  const [newChip, setNewChip] = useState({});

  const fileInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState("");
  const [initialModalData, setInitialModalData] = useState();

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setActiveModal("");
    setInitialModalData([]);
  };

  const acedemicFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "start_year",
      fieldLabel: "Start Year",
      type: "date",
      placeholder: "Select start date",
    },
    {
      fieldName: "end_year",
      fieldLabel: "End Year",
      type: "date",
      placeholder: "Select end date",
    },
    {
      fieldName: "school_name",
      fieldLabel: "School Name",
      type: "text",
      placeholder: "Enter school name",
    },
    {
      fieldName: "license",
      fieldLabel: "License",
      type: "text",
      placeholder: "Enter license (e.g., BE)",
    },
    {
      fieldName: "expert",
      fieldLabel: "Expert",
      type: "text",
      placeholder: "Enter expert area",
    },
  ];

  const familyFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "name",
      fieldLabel: "Name",
      type: "text",
      placeholder: "Enter name",
    },
    {
      fieldName: "relationship",
      fieldLabel: "Relationship",
      type: "text",
      placeholder: "Enter relationship",
    },
    {
      fieldName: "age",
      fieldLabel: "Age",
      type: "number",
      placeholder: "Enter age",
    },
    {
      fieldName: "occupation",
      fieldLabel: "Occupation",
      type: "text",
      placeholder: "Enter occupation",
    },
  ];

  const workExperienceFields = [
    { fieldName: "id", fieldLabel: "", type: "", placeholder: "" },
    {
      fieldName: "start_year",
      fieldLabel: "Start Year",
      type: "date",
      placeholder: "Select start date",
    },
    {
      fieldName: "end_year",
      fieldLabel: "End Year",
      type: "date",
      placeholder: "Select end date",
    },
    {
      fieldName: "job_description",
      fieldLabel: "Job Description",
      type: "text",
      placeholder: "Enter job description",
    },
    {
      fieldName: "equipment_used",
      fieldLabel: "Equipment Used",
      type: "text",
      placeholder: "Enter equipment used",
    },
    {
      fieldName: "company_name",
      fieldLabel: "Company Name",
      type: "text",
      placeholder: "Enter company name",
    },
  ];

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ values, setFieldValue, errors }) => {
          // const handleAddChip = (fieldName) => {
          //     if (newChip && !values[fieldName].includes(newChip)) {
          //         const updatedValues = [...values[fieldName], newChip];
          //         setFieldValue(fieldName, updatedValues);
          //         setNewChip('');
          //     }
          // };
          console.log("values", errors);
          const handleAddChip = (fieldName) => {
            const inputValue = newChip[fieldName];
            if (inputValue && !values[fieldName].includes(inputValue)) {
              const updatedValues = [...values[fieldName], inputValue];
              setFieldValue(fieldName, updatedValues);

              setNewChip((prev) => ({ ...prev, [fieldName]: "" })); // Clear only the relevant field
            }
          };

          // const handleRemoveChip = (fieldName, chipToRemove) => {
          //     const updatedValues = values[fieldName].filter(chip => chip !== chipToRemove);
          //     setFieldValue(fieldName, updatedValues);
          // };
          const handleRemoveChip = (chipToRemove, fieldName) => {
            const updatedValues = values[fieldName].filter(
              (chip) => chip !== chipToRemove,
            );
            setFieldValue(fieldName, updatedValues);
          };

          // const handleAddChip = () => {
          //     if (newChip && !values.skill.includes(newChip)) {
          //         const updatedSkills = [...values.skill, newChip];
          //         setFieldValue('skill', updatedSkills); // Update Formik state
          //         setNewChip(''); // Clear local input
          //     }
          // };

          // const handleRemoveChip = (chipToRemove) => {
          //     const updatedSkills = values.skill.filter(chip => chip !== chipToRemove);
          //     setFieldValue('skill', updatedSkills); // Update Formik state
          // };

          // const handleKeyDown = (e, fieldName) => {
          //     if (e.key === 'Enter') {
          //         e.preventDefault(); // Prevent form submission
          //         handleAddChip(fieldName);
          //     }
          // };
          const handleKeyDown = (e, fieldName) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddChip(fieldName);
            }
          };
          console.log(values);
          return (
            <Form>
              <div className="row">
                {/* <div className="col-md-4 px-3 py-2" >
                                    <label className='form-label'>Company Name </label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='Enter Company Name  '
                                        name='employeer_name'
                                        disabled={role === 'intermediate'}
                                    />
                                    <ErrorMessage name='employeer_name' component='div' className="text-danger" />
                                </div> */}
                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Name</label>
                  <Field
                    type="text"
                    className="form-control"
                    placeholder="Enter Fullname"
                    name="name"
                    disabled={role === "intermediate" ||role == "management"}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>

                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>Email</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter User Email'
                                    name='email'
                                    disabled={role === 'intermediate'}
                                />
                                <ErrorMessage name='email' component='div' className="text-danger" />
                            </div> */}

                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Phone Number</label>
                  <Field
                    type="number"
                    className="form-control"
                    min={0}
                    placeholder="Enter Phone Number"
                    name="phone"
                    disabled={role === "intermediate" ||role == "management"} 
                  />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-danger"
                  />
                </div>

                {/* <div className="col-md-4 px-3 py-2">
                                <label className="form-label">Skills</label>
                                <div className="chips-input-wrapper" style={{ position: 'relative' }}>
                                    <div className="chips-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={newChip}
                                            onChange={(e) => setNewChip(e.target.value)}
                                            onKeyDown={(e) => handleKeyDown(e, "skill")}
                                            placeholder="Add a chip and press Enter"
                                            disabled={role === 'intermediate'}
                                        />
                                        <ErrorMessage name='skill' component='div' className="text-danger" />
                                        {values.skill.map((chip, index) => (
                                            <div key={index} className="chip" style={{ display: 'flex', alignItems: 'center', padding: '0 8px', backgroundColor: '#007bff', color: 'white', borderRadius: '16px' }}>
                                                {chip}
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ml-2"
                                                    aria-label="Close"
                                                    onClick={() => handleRemoveChip(chip,"skill")}
                                                    disabled={role === 'intermediate'}
                                                ></button>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div> */}

                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Current Salary</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Current Salary'
                                    name='current_salary'
                                    disabled={role === 'intermediate'} 
                                />
                                <ErrorMessage name='current_salary' component='div' className="text-danger" />
                            </div> */}

                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Expected Salary</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Expected Salary'
                                    name='expected_salary'
                                    disabled={role === 'intermediate'} 
                                />
                                <ErrorMessage name='expected_salary' component='div' className="text-danger" />

                            </div> */}

                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Status</label>
                                <Field as="select" className='form-select' name="status"  disabled={role === 'intermediate'} >
                                    <option value="" selected hidden label="Select User Role" />
                                    <option value="Immediate Joiner">Immediate Joiner</option>
                                    <option value="Notice Period">Notice Period</option>
                                </Field >
                                <ErrorMessage name='status' component='div' className="text-danger" />
                            </div> */}

                {/* {values.status === "Notice Period" && (
                                <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>Notice period</label>
                                    <Field
                                        type='text'
                                        className='form-control'
                                        placeholder='Enter notice period'
                                        name='notice_period'
                                        disabled={role === 'intermediate'} 
                                    />
                                    <ErrorMessage name='notice_period' component='div' className="text-danger" />

                                </div>)} */}

                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Gender</label>
                  <Field
                    as="select"
                    className="form-select"
                    name="sex"
                    disabled={role === "intermediate" ||role == "management"}
                  >
                    <option
                      value=""
                      selected
                      hidden
                      label="Select the Gender"
                    />
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                  </Field>
                  <ErrorMessage
                    name="sex"
                    component="div"
                    className="text-danger"
                  />
                </div>

                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Location</label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Location'
                                    name='location'
                                    disabled={role === 'intermediate'} 
                                />
                                <ErrorMessage name='location' component='div' className="text-danger" />
                            </div> */}

                {/* <div className="col-md-6 px-3 py-2">
                                <label className='form-label'>Preferred </label>
                                <Field as="select" className='form-select' name="mode"  disabled={role === 'intermediate'} >
                                    <option value="" selected hidden label="Select the Preferred" />
                                    <option value="Remote">Remote</option>
                                    <option value="Work From Office">Work From Office</option>
                                </Field >
                                <ErrorMessage name='mode' component='div' className="text-danger" />
                            </div> */}

                {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>Experience (Year) </label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Total Experience'
                                    name='years_of_exp'
                                    disabled={role === 'intermediate'}
                                />
                                <ErrorMessage name='years_of_exp' component='div' className="text-danger" />

                            </div> */}

                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Japanese language level </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="language"
                    disabled={role === "intermediate" || role === "management"}
                  >
                    <option
                      value=""
                      selected
                      hidden
                      label="Select Japanese language level"
                    />
                    <option value="Beginner">Beginner</option>
                    <option value="N5">N5</option>
                    <option value="N4">N4</option>
                    <option value="N3">N3</option>
                    <option value="N2">N2</option>
                    <option value="N1">N1</option>
                  </Field>
                  <ErrorMessage
                    name="language"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Resume</label>
                  <input
                    type="file"
                    className="form-control"
                    name="file"
                    onChange={(event) => {
                      setFieldValue("file", event.target.files[0]); // Set the file to Formik state
                    }}
                    disabled={role === "intermediate" || role === "management" ? true : false}
                  />
                  <ErrorMessage
                    name="file"
                    component="div"
                    className="text-danger"
                  />

                  {values.file && typeof values.file === "string" && (
                    <a
                      href={values.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                    >
                      Download Current File
                    </a>
                  )}
                </div>
                <div className="col-md-4 px-3 py-2">
                  <label className="form-label">Japanese Resume</label>
                  <input
                    type="file"
                    className="form-control"
                    name="japanese_file"
                    onChange={(event) => {
                      setFieldValue("japanese_file", event.target.files[0]); // Set the file to Formik state
                    }}
                    disabled={role === "hr" || role === "management" ? true : false}
                  />
                  <ErrorMessage
                    name="japanese_file"
                    component="div"
                    className="text-danger"
                  />

                  {values.japanese_file &&
                    typeof values.japanese_file === "string" && (
                      <a
                        href={values.japanese_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-block mt-2"
                      >
                        Download Current File
                      </a>
                    )}
                </div>

                {(role === "admin" ||
                  role === "management" ||
                  role == "intermediate" ||
                  role == "hr") && (
                  <>
                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Company Name </label>
                      <Field
                        type="text"
                        className="form-control"
                        placeholder="Enter Company Name  "
                        name="employeer_name"
                        disabled={role === "intermediate" }
                      />
                      <ErrorMessage
                        name="employeer_name"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* <div className="col-md-4 px-3 py-2">
                                    <label className='form-label'>Emergency Contact </label>
                                    <Field
                                        type='number'
                                        className='form-control'
                                        placeholder='Enter Emergency Contact Number'
                                        name='emergency_contact'
                                    // disabled={role === 'intermediate'} 
                                    />
                                    <ErrorMessage name='emergency_contact' component='div' className="text-danger" />
                                </div> */}

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Visa </label>
                      <input
                        type="file"
                        className="form-control"
                        name="visa"
                        onChange={(event) => {
                          setFieldValue("visa", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="visa"
                        component="div"
                        className="text-danger"
                      />

                      {values.visa && typeof values.visa === "string" && (
                        <a
                          href={values.visa}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                        >
                          Download Current File
                        </a>
                      )}
                    </div>
                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Emergency Contact </label>
                      <Field
                        type="number"
                        min={0}
                        className="form-control"
                        placeholder="Enter Emergency Contact Number"
                        name="emergency_contact"
                        // disabled={role === 'intermediate'}
                      />
                      <ErrorMessage
                        name="emergency_contact"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                     hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">COE </label>
                      <input
                        type="file"
                        className="form-control"
                        name="coe"
                        onChange={(event) => {
                          setFieldValue("coe", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="coe"
                        component="div"
                        className="text-danger"
                      />

                      {values.coe && typeof values.coe === "string" && (
                        <a
                          href={values.coe}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                        >
                          Download Current File
                        </a>
                      )}
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Air Ticket </label>
                      <input
                        type="file"
                        className="form-control"
                        name="air_ticket"
                        onChange={(event) => {
                          setFieldValue("air_ticket", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="air_ticket"
                        component="div"
                        className="text-danger"
                      />

                      {values.air_ticket &&
                        typeof values.air_ticket === "string" && (
                          <a
                            href={values.air_ticket}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">
                        Employement Contract{" "}
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="employement_contract"
                        onChange={(event) => {
                          setFieldValue(
                            "employement_contract",
                            event.target.files[0],
                          ); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="employement_contract"
                        component="div"
                        className="text-danger"
                      />

                      {values.employement_contract &&
                        typeof values.employement_contract === "string" && (
                          <a
                            href={values.employement_contract}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Resident File</label>
                      <input
                        type="file"
                        className="form-control"
                        name="resident_copy  "
                        onChange={(event) => {
                          setFieldValue("resident_copy", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="resident_copy"
                        component="div"
                        className="text-danger"
                      />

                      {values.resident_copy &&
                        typeof values.resident_copy === "string" && (
                          <a
                            href={values.resident_copy}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Passport</label>
                      <input
                        type="file"
                        className="form-control"
                        name="passport_copy "
                        onChange={(event) => {
                          setFieldValue("passport_copy", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="passport_copy"
                        component="div"
                        className="text-danger"
                      />

                      {values.passport_copy &&
                        typeof values.passport_copy === "string" && (
                          <a
                            href={values.passport_copy}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    {/* <div className="col-md-4 px-3 py-2">
                                <label className='form-label'>Contact Details  </label>
                                <Field
                                    type='text'
                                    className='form-control'
                                    placeholder='Enter Contact Details  '
                                    name='contact_details'
                                />
                                <ErrorMessage name='contact_details' component='div' className="text-danger" />
                            </div> */}

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Arrival Date </label>
                      <DatePicker
                        className="form-control"
                        placeholderText="Select Your Arrival Date "
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        selected={values.arrival_date}
                        onChange={(date) => {
                          setFieldValue("arrival_date", date);
                        }}
                      />
                      <ErrorMessage
                        name="arrival_date"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Option File </label>
                      <input
                        type="file"
                        className="form-control"
                        name="option_file"
                        onChange={(event) => {
                          setFieldValue("option_file", event.target.files[0]); // Set the file to Formik state
                        }}
                        // disabled={role === "hr" ? true: false}
                      />
                      <ErrorMessage
                        name="option_file"
                        component="div"
                        className="text-danger"
                      />

                      {values.option_file &&
                        typeof values.option_file === "string" && (
                          <a
                            href={values.option_file}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div
                      className="col-md-4 px-3 py-2"
                      hidden={role !== "admin" && role !== "management"}
                    >
                      <label className="form-label">Remarks </label>
                      <Field
                        type="text"
                        className="form-control"
                        placeholder="Enter remarks "
                        name="remarks"
                        // disabled={role === 'intermediate'}
                      />
                      <ErrorMessage
                        name="remarks"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </>
                )}

                {(role === "admin" ||
                  role === "hr" ||
                  role === "intermediate") && (
                  <>
                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Admission Number</label>
                                        <Field className='form-control' placeholder='Enter Admission Number' name="admission_number" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='admission_number' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Admission Fee</label>
                                        <Field className='form-control' placeholder='Enter Admission Fee' name="ad_fees" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='ad_fees' component='div' className="text-danger" />
                                    </div> */}

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Date of Admission</label>
                                        <DatePicker className='form-control' placeholderText='Select Your Date of Admission'
                                            peekNextMonth showMonthDropdown showYearDropdown dropdownMode='select'
                                            dateFormat='dd/MM/yyyy'
                                            selected={values.date_of_admission} onChange={(date) => { setFieldValue('date_of_admission', date) }}
                                            disabled={role === 'intermediate'}
                                        />
                                        <ErrorMessage name='date_of_admission' component='div' className="text-danger" />
                                    </div> */}

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">DOB</label>
                      <DatePicker
                        className="form-control"
                        placeholderText="Select Your DOB"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                        selected={values.dob}
                        onChange={(date) => {
                          setFieldValue("dob", date);
                          const today = new Date();
                          const age =
                            today.getFullYear() -
                            date.getFullYear() -
                            (new Date(
                              today.getFullYear(),
                              date.getMonth(),
                              date.getDate(),
                            ) > today
                              ? 1
                              : 0);
                          if (typeof age === "number" && !isNaN(age)) {
                            setFieldValue("age", age);
                          }
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />
                      <ErrorMessage
                        name="dob"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Passport Number</label>
                                        <Field className='form-control' placeholder='Enter Passport Number' name="passport_no" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='passport_no' component='div' className="text-danger" />
                                    </div> */}

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Nationality</label>
                                        <Field className='form-control' placeholder='Enter Nationality' name="nationality" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='nationality' component='div' className="text-danger" />
                                    </div> */}

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Religion</label>
                      <Field
                        className="form-control"
                        placeholder="Enter Religion"
                        name="religion"
                        disabled={role === "intermediate" || role === "management"}
                      />
                      <ErrorMessage
                        name="religion"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Educational Qualification</label>
                                        <Field className='form-control' placeholder='Enter Educational Qualification' name="educational_qualification" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='educational_qualification' component='div' className="text-danger" />
                                    </div>

                                    <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Additional Qualification</label>
                                        <Field className='form-control' placeholder='Enter Additional Qualification' name="additional_qualification" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='additional_qualification' component='div' className="text-danger" />
                                    </div> */}

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Marital Status</label>
                                        <Field as="select" className='form-select' name='marital_status' disabled={role === 'intermediate'} >
                                            <option value="" selected hidden label="Select an option" />
                                            <option value="Married">Married</option>
                                            <option value="UnMarried">UnMarried</option>
                                        </Field>
                                    </div> */}

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Height</label>
                      <Field
                        className="form-control"
                        min={0}
                        placeholder="Enter Height"
                        type="number"
                        name="height"
                        disabled={role === "intermediate" || role === "management"}
                      />
                      <ErrorMessage
                        name="height"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Weight</label>
                      <Field
                        className="form-control"
                        placeholder="Enter Weight"
                        min={0}
                        type="number"
                        name="weight"
                        disabled={role === "intermediate" || role === "management"}
                      />
                      <ErrorMessage
                        name="weight"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">
                        Communication Address
                      </label>
                      <Field
                        className="form-control"
                        placeholder="Enter Communication Address"
                        name="communication"
                        disabled={role === "intermediate" || role === "management"}
                      />
                      <ErrorMessage
                        name="communication"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Reference</label>
                                        <Field className='form-control' placeholder='Enter Reference' name="reference" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='reference' component='div' className="text-danger" />
                                    </div> */}

                    {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>English Knowledge</label>
                                        <Field as="select" className='form-select' name='english_knowledge' disabled={role === 'intermediate'} >
                                            <option value="" selected hidden label="Select an option" />
                                            <option value="Good">Good</option>
                                            <option value="Average">Average</option>
                                            <option value="Poor">Poor</option>
                                        </Field>
                                    </div> */}

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Full size photo</label>
                      <input
                        type="file"
                        className="form-control"
                        placeholder="Enter your photo"
                        onChange={(event) => {
                          setFieldValue(
                            "profile_pic",
                            event.currentTarget.files[0],
                          );
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />

                      {/* {values.profile_pic && (
                                    <div className='mt-2 profileimage'>
                                        {values.profile_pic.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.profile_pic)}
                                                alt="Selected Profile "
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.profile_pic)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )} */}

                      {values.profile_pic &&
                        typeof values.profile_pic === "string" && (
                          <a
                            href={values.profile_pic}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Signature</label>
                      <input
                        type="file"
                        className="form-control"
                        placeholder="Enter your signature"
                        onChange={(event) => {
                          setFieldValue("sign", event.currentTarget.files[0]);
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />
                      {/* 
                                {values.sign && (
                                    <div className='mt-2 profileimage'>
                                        {values.sign.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.sign)}
                                                alt="Selected Signature"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.sign)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )} */}

                      {values.sign && typeof values.sign === "string" && (
                        <a
                          href={values.sign}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                        >
                          Download Current File
                        </a>
                      )}
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">
                        Educational Certificate
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        placeholder="Enter your name"
                        onChange={(event) => {
                          setFieldValue(
                            "educationalCertificate",
                            event.currentTarget.files[0],
                          );
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />

                      {/* {values.educationalCertificate && (
                                    <div className='mt-2 profileimage'>
                                        {values.educationalCertificate.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.educationalCertificate)}
                                                alt="Selected educationalCertificate"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.educationalCertificate)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )} */}

                      {values.educationalCertificate &&
                        typeof values.educationalCertificate === "string" && (
                          <a
                            href={values.educationalCertificate}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">Medical Report</label>
                      <input
                        type="file"
                        className="form-control"
                        placeholder="Enter your name"
                        onChange={(event) => {
                          setFieldValue(
                            "medicalReport",
                            event.currentTarget.files[0],
                          );
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />
                      {/* {values.medicalReport && (
                                    <div className='mt-2 profileimage'>
                                        {values.medicalReport.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.medicalReport)}
                                                alt="Selected medicalReport"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.medicalReport)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )} */}

                      {values.medicalReport &&
                        typeof values.medicalReport === "string" && (
                          <a
                            href={values.medicalReport}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>

                    <div className="col-md-4 px-3 py-2">
                      <label className="form-label">
                        Vaccination Certificate
                      </label>
                      <input
                        ref={fileInputRef}
                        type="file"
                        className="form-control"
                        placeholder="Enter your name"
                        onChange={(event) => {
                          setFieldValue(
                            "vaccinationCertificate",
                            event.currentTarget.files[0],
                          );
                        }}
                        disabled={role === "intermediate" || role === "management"}
                      />
                      {/* {values.vaccinationCertificate && (
                                    <div className='mt-2 profileimage'>
                                        {values.vaccinationCertificate.type.includes('image') ? (
                                            <img
                                                src={URL.createObjectURL(values.vaccinationCertificate)}
                                                alt="Selected vaccinationCertificate"
                                            />
                                        ) : (
                                            <embed
                                                src={URL.createObjectURL(values.vaccinationCertificate)}

                                                type="application/pdf"
                                            />
                                        )}
                                    </div>
                                )} */}

                      {values.vaccinationCertificate &&
                        typeof values.vaccinationCertificate === "string" && (
                          <a
                            href={values.vaccinationCertificate}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`d-block mt-2 ${role === "intermediate" ? "hidden" : ""}`}
                          >
                            Download Current File
                          </a>
                        )}
                    </div>
                  </>
                )}

                <>
                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Age</label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Age"
                      name="age"
                    //   disabled={role === "intermediate"}
                    disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="age"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Birth Place</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Birth Place"
                      name="place_of_birth"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="place_of_birth"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Reason For Apply</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Reason"
                      name="reason_for_apply"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="reason_for_apply"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Co-operative Living</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Co-operative Living"
                      name="cooperative_living"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="cooperative_living"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Favourite Subject</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Favourite Subject"
                      name="favorite_subject"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="favorite_subject"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">
                      License & Qualification
                    </label>
                    <Field
                      className="form-control"
                      placeholder="Enter License and Qualification"
                      name="licenses_and_qualifications"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="licenses_and_qualifications"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Tatto</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="tattoo"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="tattoo"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Blood Type</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Blood Type"
                      name="blood_type"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="blood_type"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Right Vision</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Right Vision"
                      name="right_vision"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="right_vision"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Left Vision</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Left Vision"
                      name="left_vision"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="left_vision"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Color-Blindness</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Color-Blindness"
                      name="color_blindness"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="color_blindness"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Blood Pressure</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Blood Pressure"
                      name="blood_pressure"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="blood_pressure"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  {/* <div className="col-md-4 px-3 py-2">
                                        <label className='form-label'>Dominant Hand</label>
                                        <Field className='form-control' placeholder='Enter Dominant Hand' name="dominant_hand" disabled={role === 'intermediate'} />
                                        <ErrorMessage name='dominant_hand' component='div' className="text-danger" />
                                    </div> */}

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Dominant Hand</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="dominant_hand"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Right Hand">Right Hand</option>
                      <option value="Left Hand">Left Hand</option>
                    </Field>
                    <ErrorMessage
                      name="dominant_hand"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Foods Not Eat</label>
                    <div
                      className="chips-input-wrapper"
                      style={{ position: "relative" }}
                    >
                      <div
                        className="chips-container"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={newChip}
                                                onChange={(e) => setNewChip(e.target.value)}
                                                onKeyDown={(e) => handleKeyDown(e, "foods_cannot_eat")}
                                                placeholder="Add a chip and press Enter"
                                                disabled={role === 'intermediate'}
                                            /> */}
                        <input
                          type="text"
                          className="form-control"
                          value={newChip["foods_cannot_eat"] || ""}
                          onChange={(e) =>
                            setNewChip((prev) => ({
                              ...prev,
                              foods_cannot_eat: e.target.value,
                            }))
                          }
                          onKeyDown={(e) =>
                            handleKeyDown(e, "foods_cannot_eat")
                          }
                          placeholder="Add a chip and press Enter"
                          disabled={role === "intermediate" || role === "management"}
                        />
                        <ErrorMessage
                          name="foods_cannot_eat"
                          component="div"
                          className="text-danger"
                        />
                        {values.foods_cannot_eat.map((chip, index) => (
                          <div
                            key={index}
                            className="chip"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "0 8px",
                              backgroundColor: "#007bff",
                              color: "white",
                              borderRadius: "16px",
                            }}
                          >
                            {chip}
                            <button
                              type="button"
                              className="btn-close btn-close-white ml-2"
                              aria-label="Close"
                              onClick={() =>
                                handleRemoveChip(chip, "foods_cannot_eat")
                              }
                              disabled={role === "intermediate" || role === "management"}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Smoking Habit</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="smoking"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="smoking"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Drinking Habit</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="drinking_beer"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="drinking_beer"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Hobbies</label>
                    <div
                      className="chips-input-wrapper"
                      style={{ position: "relative" }}
                    >
                      <div
                        className="chips-container"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={newChip}
                                                onChange={(e) => setNewChip(e.target.value)}
                                                onKeyDown={(e) => handleKeyDown(e, "hobbies")}
                                                placeholder="Add a chip and press Enter"
                                                disabled={role === 'intermediate'}
                                            /> */}
                        <input
                          type="text"
                          className="form-control"
                          value={newChip["hobbies"] || ""}
                          onChange={(e) =>
                            setNewChip((prev) => ({
                              ...prev,
                              hobbies: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => handleKeyDown(e, "hobbies")}
                          placeholder="Add a chip and press Enter"
                          disabled={role === "intermediate" || role === "management"}
                        />
                        <ErrorMessage
                          name="hobbies"
                          component="div"
                          className="text-danger"
                        />
                        {values.hobbies.map((chip, index) => (
                          <div
                            key={index}
                            className="chip"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "0 8px",
                              backgroundColor: "#007bff",
                              color: "white",
                              borderRadius: "16px",
                            }}
                          >
                            {chip}
                            <button
                              type="button"
                              className="btn-close btn-close-white ml-2"
                              aria-label="Close"
                              onClick={() => handleRemoveChip(chip, "hobbies")}
                              disabled={role === "intermediate" || role === "management"}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Strengths</label>
                    <div
                      className="chips-input-wrapper"
                      style={{ position: "relative" }}
                    >
                      <div
                        className="chips-container"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={newChip}
                                                onChange={(e) => setNewChip(e.target.value)}
                                                onKeyDown={(e) => handleKeyDown(e, "strengths")}
                                                placeholder="Add a chip and press Enter"
                                                disabled={role === 'intermediate'}
                                            /> */}
                        <input
                          type="text"
                          className="form-control"
                          value={newChip["strengths"] || ""}
                          onChange={(e) =>
                            setNewChip((prev) => ({
                              ...prev,
                              strengths: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => handleKeyDown(e, "strengths")}
                          placeholder="Add a chip and press Enter"
                          disabled={role === "intermediate" || role === "management"}
                        />
                        <ErrorMessage
                          name="strengths"
                          component="div"
                          className="text-danger"
                        />
                        {values.strengths.map((chip, index) => (
                          <div
                            key={index}
                            className="chip"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "0 8px",
                              backgroundColor: "#007bff",
                              color: "white",
                              borderRadius: "16px",
                            }}
                          >
                            {chip}
                            <button
                              type="button"
                              className="btn-close btn-close-white ml-2"
                              aria-label="Close"
                              onClick={() =>
                                handleRemoveChip(chip, "strengths")
                              }
                              disabled={role === "intermediate" || role === "management"}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Weaknesses </label>
                    <div
                      className="chips-input-wrapper"
                      style={{ position: "relative" }}
                    >
                      <div
                        className="chips-container"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "4px",
                        }}
                      >
                        {/* <input
                                                type="text"
                                                className="form-control"
                                                value={newChip}
                                                onChange={(e) => setNewChip(e.target.value)}
                                                onKeyDown={(e) => handleKeyDown(e, "weaknesses")}
                                                placeholder="Add a chip and press Enter"
                                                disabled={role === 'intermediate'}
                                            /> */}
                        <input
                          type="text"
                          className="form-control"
                          value={newChip["weaknesses"] || ""}
                          onChange={(e) =>
                            setNewChip((prev) => ({
                              ...prev,
                              weaknesses: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => handleKeyDown(e, "weaknesses")}
                          placeholder="Add a chip and press Enter"
                          disabled={role === "intermediate"}
                        />
                        <ErrorMessage
                          name="weaknesses"
                          component="div"
                          className="text-danger"
                        />
                        {values.weaknesses.map((chip, index) => (
                          <div
                            key={index}
                            className="chip"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "0 8px",
                              backgroundColor: "#007bff",
                              color: "white",
                              borderRadius: "16px",
                            }}
                          >
                            {chip}
                            <button
                              type="button"
                              className="btn-close btn-close-white ml-2"
                              aria-label="Close"
                              onClick={() =>
                                handleRemoveChip(chip, "weaknesses")
                              }
                              disabled={role === "intermediate" || role === "management"}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Medical History</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Medical History"
                      name="medical_history"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="medical_history"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Spouse</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="spouse"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="spouse"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Personal Income (Yen)</label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Personal Income"
                      name="personal_income"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="personal_income"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Family Income (Yen)</label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Family Income"
                      name="family_income"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="family_income"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Relatives In Japan</label>
                    <Field
                      as="select"
                      className="form-select"
                      name="relatives_in_japan"
                      disabled={role === "intermediate" || role === "management"}
                    >
                      <option value="" selected hidden label="Select" />
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="relatives_in_japan"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Japanese Address</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Address"
                      name="japanese_address"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="japanese_address"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">
                      Your Experience Visiting Japan
                    </label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Experience"
                      name="experience_coming_to_japan"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="experience_coming_to_japan"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">
                      Desired Years To Work In Japan
                    </label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Years"
                      name="desired_years_to_work_in_japan"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="desired_years_to_work_in_japan"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Savings Per Year (Yen)</label>
                    <Field
                      className="form-control"
                      type="number"
                      min={0}
                      placeholder="Enter Savings"
                      name="savings_per_year"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="savings_per_year"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Goals After Returning</label>
                    <Field
                      className="form-control"
                      placeholder="Enter Goals"
                      name="plans_or_goals_after_returning"
                      disabled={role === "intermediate" || role === "management"}
                    />
                    <ErrorMessage
                      name="plans_or_goals_after_returning"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Acedemic Details</label>
                    <div>
                      {values["academic_details"].length > 0 ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-warning me-2"
                            onClick={() => {
                              setIsModalOpen(true);
                              setActiveModal("academic_details");
                              setInitialModalData(values["academic_details"]);
                            }}
                          >
                            Update Academic Detail
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setIsModalOpen(true);
                            setActiveModal("academic_details");
                          }}
                        >
                          Add Academic Detail
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Family Details</label>
                    <div>
                      {values["family_details"].length > 0 ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-warning me-2"
                            onClick={() => {
                              setIsModalOpen(true);
                              setActiveModal("family_details");
                              setInitialModalData(values["family_details"]);
                            }}
                          >
                            Update Family Detail
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setIsModalOpen(true);
                            setActiveModal("family_details");
                          }}
                        >
                          Add Family Detail
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2">
                    <label className="form-label">Work Experience</label>
                    <div>
                      {values["work_experience_list"].length > 0 ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-warning me-2"
                            onClick={() => {
                              setIsModalOpen(true);
                              setActiveModal("work_experience_list");
                              setInitialModalData(
                                values["work_experience_list"],
                              );
                            }}
                          >
                            Update Work Experience
                          </button>
                        </>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            setIsModalOpen(true);
                            setActiveModal("work_experience_list");
                          }}
                        >
                          Add Work Experience
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4 px-3 py-2" hidden>
                    {values.english_pdf && (
                      <label className="form-label">English PDF</label>
                    )}
                    {/* <input type="file" className='form-control' placeholder='File'
                                            onChange={(event) => {
                                                setFieldValue('english_pdf', event.currentTarget.files[0]);
                                            }} disabled={role === 'intermediate'} /> */}

                    {values.english_pdf &&
                    typeof values.english_pdf === "string" ? (
                      values.english_pdf.includes(".pdf") ? (
                        <embed
                          src={values.english_pdf}
                          type="application/pdf"
                          width="100%"
                        />
                      ) : (
                        <img src={values.english_pdf} alt="candidatePdf" />
                      )
                    ) : null}

                    {values.english_pdf &&
                      typeof values.english_pdf === "string" && (
                        <a
                          href={values.english_pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download Current File
                        </a>
                      )}
                  </div>
                </>

                {isModalOpen && activeModal === "academic_details" && (
                  <MultiFieldModal
                    handleCloseModal={handleCloseModal}
                    fields={acedemicFields}
                    containerFieldName={"academic_details"}
                    modalTitle={"Add Acedamic Details"}
                    setFieldValue={setFieldValue}
                    initialData={initialModalData}
                    disabled={role === "management"}
                  />
                )}

                {isModalOpen && activeModal === "family_details" && (
                  <MultiFieldModal
                    handleCloseModal={handleCloseModal}
                    fields={familyFields}
                    containerFieldName={"family_details"}
                    modalTitle={"Add Family Details"}
                    setFieldValue={setFieldValue}
                    initialData={initialModalData}
                      disabled={role === "management"}
                  />
                )}

                {isModalOpen && activeModal === "work_experience_list" && (
                  <MultiFieldModal
                    handleCloseModal={handleCloseModal}
                    fields={workExperienceFields}
                    containerFieldName={"work_experience_list"}
                    modalTitle={"Add Work Experience"}
                    setFieldValue={setFieldValue}
                      disabled={role === "management"}
                    initialData={initialModalData}
                  />
                )}

                <div className="row mt-3">
                  <div className="col ">
                    <button
                      className="cancel-button ms-2"
                      onClick={handleBack}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button className="btn defult-button ms-2" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ResumeForm;
